export const Colors = Object.freeze({
  purple: "#9c88ff",
  grey: "#7f8fa6",
  lightGrey: "#dcdde1",
});
